import { GridItem } from '@jouzen/ecom-components/v3/GridItem';
import { LayoutGrid } from '@jouzen/ecom-components/v3/LayoutGrid';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import Motion from '@/app/components/Motion';
import SectionHeader from '@/app/components/SectionHeader';

const integrations = [
  {
    description: 'science_research_2025_research_stat_one_description',
    name: '30+ PhDs',
    title: 'science_research_2025_research_stat_one_title',
  },
  {
    description: 'science_research_2025_research_stat_two_description',
    name: '130+',
    title: 'science_research_2025_research_stat_two_title',
  },
  {
    description: 'science_research_2025_research_stat_three_description',
    name: '10+ Years',
    title: 'science_research_2025_research_stat_three_title',
  },
  {
    description: 'science_research_2025_research_stat_four_description',
    name: '14',
    title: 'science_research_2025_research_stat_four_title',
  },
];

const ResearchInnovationSection = () => {
  const t = useTranslations();

  return (
    <section className="py-20" data-cy="research-innovation-section">
      <SectionHeader
        className="mb-14 lg:mb-20"
        copy={{
          key: 'science_research_2025_research_copy',
        }}
        title={{
          key: 'science_research_2025_research_title',
        }}
      />
      <LayoutGrid>
        <GridItem colEnd={{ sm: 'main' }} colStart={{ sm: 'main' }}>
          <div className="grid grid-cols-1 gap-16 md:grid-cols-2 md:gap-x-24 md:gap-y-8 lg:grid-cols-4 lg:gap-8 xl:gap-32">
            {integrations.map(({ description, name, title }, index) => (
              <div key={name}>
                <Motion
                  animate={{ opacity: 1 }}
                  className="flex w-full flex-col items-center text-center"
                  initial={{ opacity: 0 }}
                  transition={{
                    delay: 0.05 * index,
                    duration: 0.5,
                    type: 'tween',
                  }}
                  viewport={{ once: true }}
                >
                  <Typography
                    align="center"
                    className="mb-2 font-normal"
                    font="serif"
                    variant="h3"
                    weight="thin"
                  >
                    {t(title)}
                  </Typography>
                  <Typography align="center" className="max-w-96 leading-snug">
                    {t(description)}
                  </Typography>
                </Motion>
              </div>
            ))}
          </div>
        </GridItem>
      </LayoutGrid>
    </section>
  );
};

export default ResearchInnovationSection;
